export default "__VITE_ASSET__CE5bOt94__"